import React, { useState } from 'react';
import styles from './DutchingCalculator.module.css';
import { clearFormatting, handleBlurCurrency } from '../../../utils/calc-utils';

const DutchingCalculator = () => {
  const [fields, setFields] = useState({
    dutchBetType: 'Cash Bet',
    outcome1Name: 'Team A',
    outcome2Name: 'Team B',
    outcome1Stake: '',
    outcome1Odds: '',
    outcome2Odds: '',
    outcome3Name: 'The Draw',
    outcome3Odds: '',
  });
  const [result, setResult] = useState('');
  const [isResultVisible, setIsResultVisible] = useState(false);
  const [showOutcome3, setShowOutcome3] = useState(false);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFields((prevFields) => ({ ...prevFields, [id]: value }));
  };

  const handleAddOutcome = () => {
    setShowOutcome3(true);
  };

  const handleRemoveOutcome = () => {
    setShowOutcome3(false);
    setFields((prevFields) => ({
      ...prevFields,
      outcome3Name: 'Draw',
      outcome3Odds: '',
    }));
  };

  const handleCalculate = () => {
    const { dutchBetType, outcome1Name, outcome1Odds, outcome1Stake, outcome2Name, outcome2Odds, outcome3Name, outcome3Odds } = fields;
    const parsedOutcome1Stake = clearFormatting(outcome1Stake);
    const parsedOutcome1Odds = parseFloat(outcome1Odds);
    const parsedOutcome2Odds = parseFloat(outcome2Odds);
    const parsedOutcome3Odds = parseFloat(outcome3Odds);
    let outcome2Stake, outcome3Stake, profit;

    if (!outcome1Name || !outcome1Odds || !outcome1Stake || !outcome2Name || !outcome2Odds || (showOutcome3 && (!outcome3Name || !outcome3Odds))) {
      setResult('Finish entering all your bet details before calculating');
    } else {
      if (dutchBetType === 'SNR Bonus Bet') {
        outcome2Stake = (parsedOutcome1Stake * (parsedOutcome1Odds - 1)) / parsedOutcome2Odds;
        profit = (parsedOutcome1Stake * (parsedOutcome1Odds - 1)) - outcome2Stake;
        if (showOutcome3) {
          outcome3Stake = (parsedOutcome1Stake * (parsedOutcome1Odds - 1)) / parsedOutcome3Odds;
          profit -= outcome3Stake;
        }
      } else if (dutchBetType === 'SR Bonus Bet') {
        outcome2Stake = (parsedOutcome1Stake * parsedOutcome1Odds) / parsedOutcome2Odds;
        profit = (parsedOutcome1Stake * parsedOutcome1Odds) - outcome2Stake;
        if (showOutcome3) {
          outcome3Stake = (parsedOutcome1Stake * parsedOutcome1Odds) / parsedOutcome3Odds;
          profit -= outcome3Stake;
        }
      } else if (dutchBetType === 'Cash Bet') {
        outcome2Stake = (parsedOutcome1Stake * parsedOutcome1Odds) / parsedOutcome2Odds;
        profit = (parsedOutcome1Stake * parsedOutcome1Odds) - outcome2Stake - parsedOutcome1Stake;
        if (showOutcome3) {
          outcome3Stake = (parsedOutcome1Stake * parsedOutcome1Odds) / parsedOutcome3Odds;
          profit -= outcome3Stake;
        }
      }

      let resultHTML;
      const profitText = profit >= 0 ? 'profit' : 'loss';
      const profitClass = profit >= 0 ? styles.profitTextGreen : styles.profitTextRed;
      const absoluteProfit = Math.abs(profit);
      const formattedProfit = `${profit >= 0 ? '$' : '-$'}${absoluteProfit.toFixed(2)}`;

      if (showOutcome3) {
        resultHTML = `Place $${outcome2Stake.toFixed(2)} on ${outcome2Name} and place $${outcome3Stake.toFixed(2)} on ${outcome3Name} to lock-in a <span class="${profitClass}">${profitText} of ${formattedProfit}</span> (${((profit / (parsedOutcome1Stake + outcome2Stake + outcome3Stake)) * 100).toFixed(2)}%)`;
      } else {
        resultHTML = `Place $${outcome2Stake.toFixed(2)} on ${outcome2Name} to lock-in a <span class="${profitClass}">${profitText} of ${formattedProfit}</span> (${((profit / (parsedOutcome1Stake + outcome2Stake)) * 100).toFixed(2)}%)`;
      }

      setResult(resultHTML);
    }
    setIsResultVisible(true);
  };

  return (
    <div className={styles.dutchingCalculator}>
      <h1 className={styles.calculatorTitle}>Dutching Calculator</h1>
      <div className={styles.containerWrapper}>
        <div className={styles.container}>
          <div className={styles.box}>
            <span className={styles.label}>Bet Type:</span>
            <select
              className={styles.dropdown}
              id="dutchBetType"
              value={fields.dutchBetType}
              onChange={handleInputChange}
            >
              <option value="Cash Bet">Cash Bet</option>
              <option value="SNR Bonus Bet">SNR Bonus Bet</option>
              <option value="SR Bonus Bet">SR Bonus Bet</option>
            </select>
          </div>
          <div className={styles.box}>
            <span className={styles.label}>Outcome 1 Name:</span>
            <input
              className={`${styles.input} ${styles.outcome1}`}
              type="text"
              id="outcome1Name"
              value={fields.outcome1Name}
              onChange={handleInputChange}
              placeholder="Enter Outcome 1 name"
            />
          </div>
          <div className={styles.box}>
            <span className={styles.label}>Outcome 2 Name:</span>
            <input
              className={`${styles.input} ${styles.outcome2}`}
              type="text"
              id="outcome2Name"
              value={fields.outcome2Name}
              onChange={handleInputChange}
              placeholder="Enter Outcome 2 name"
            />
          </div>
          {showOutcome3 && (
            <div className={styles.box}>
              <span className={styles.label}>Outcome 3 Name:</span>
              <input
                className={`${styles.input} ${styles.outcome3}`}
                type="text"
                id="outcome3Name"
                value={fields.outcome3Name}
                onChange={handleInputChange}
                placeholder="Enter Outcome 3 name"
              />
            </div>
          )}
          <div className={styles.box}>
            <span className={styles.label}>Outcome 1 Stake ($):</span>
            <input
              className={`${styles.input} ${styles.stake}`}
              type="text"
              id="outcome1Stake"
              value={fields.outcome1Stake}
              onChange={handleInputChange}
              onBlur={(e) => handleBlurCurrency(e, setFields)}
              placeholder="Enter Outcome 1 stake"
            />
          </div>
          <div className={styles.box}>
            <span className={styles.label}>Outcome 1 Odds:</span>
            <input
              className={`${styles.input} ${styles.odds}`}
              type="number"
              id="outcome1Odds"
              value={fields.outcome1Odds}
              onChange={handleInputChange}
              placeholder="Enter Outcome 1 odds"
            />
          </div>
          <div className={styles.box}>
            <span className={styles.label}>Outcome 2 Odds:</span>
            <input
              className={`${styles.input} ${styles.odds}`}
              type="number"
              id="outcome2Odds"
              value={fields.outcome2Odds}
              onChange={handleInputChange}
              placeholder="Enter Outcome 2 odds"
            />
          </div>
          {showOutcome3 && (
            <div className={styles.box}>
              <span className={styles.label}>Outcome 3 Odds:</span>
              <input
                className={`${styles.input} ${styles.odds}`}
                type="number"
                id="outcome3Odds"
                value={fields.outcome3Odds}
                onChange={handleInputChange}
                placeholder="Enter Outcome 3 odds"
              />
            </div>
          )}
          <div className={`${styles.box} ${styles.buttonContainer}`}>
            {!showOutcome3 && (
              <button
                type="button"
                onClick={handleAddOutcome}
                className={styles.greyAccentButton}
              >
                Add a 3rd Outcome
              </button>
            )}
            {showOutcome3 && (
              <button
                type="button"
                onClick={handleRemoveOutcome}
                className={`${styles.greyAccentButton} ${styles.fullWidth}`}
              >
                Remove 3rd Outcome
              </button>
            )}
          </div>
          <button onClick={handleCalculate}>Calculate</button>
          <div className={`${styles.result} ${isResultVisible ? styles.resultVisible : ''}`} id="resultTeam" dangerouslySetInnerHTML={{ __html: result }}></div>
        </div>
        <div className={styles.howToUse}>
          <h2>How to Use This Calculator</h2>
          <p>1. <strong>Select Bet Type:</strong> Choose the type of bet from the dropdown menu (e.g., SNR Bonus Bet).</p>
          <p>2. <strong>Outcome 1 Name:</strong> Optional: Enter the name of the first outcome (e.g., Team A).</p>
          <p>3. <strong>Outcome 2 Name:</strong> Optional: Enter the name of the second outcome (e.g., Team B).</p>
          {showOutcome3 && (
            <>
              <p>4. <strong>Outcome 3 Name:</strong> Optional: Enter the name of the third outcome (e.g., Draw).</p>
              <p>5. <strong>Outcome 1 Stake ($):</strong> Input the stake amount for the first outcome in the "Outcome 1 Stake ($)" field.</p>
              <p>6. <strong>Outcome 1 Odds:</strong> Input the odds for the first outcome in the "Outcome 1 Odds" field.</p>
              <p>7. <strong>Outcome 2 Odds:</strong> Input the odds for the second outcome in the "Outcome 2 Odds" field.</p>
              <p>8. <strong>Outcome 3 Odds:</strong> Input the odds for the third outcome in the "Outcome 3 Odds" field.</p>
            </>
          )}
          {!showOutcome3 && (
            <>
              <p>4. <strong>Outcome 1 Stake ($):</strong> Input the stake amount for the first outcome in the "Outcome 1 Stake ($)" field.</p>
              <p>5. <strong>Outcome 1 Odds:</strong> Input the odds for the first outcome in the "Outcome 1 Odds" field.</p>
              <p>6. <strong>Outcome 2 Odds:</strong> Input the odds for the second outcome in the "Outcome 2 Odds" field.</p>
            </>
          )}
          <p><strong>Reminders:</strong></p>
          <ul>
            <li>Always place your bet on the other outcome at a <strong>DIFFERENT</strong> bookie. If you fail to do this the bookie is likely to void your bets, especially if one of the bets is bonus cash.</li>
            <li>When using for a conversion, the bonus cash always goes on the high odds outcome, which should be Outcome 1 and Odds 1.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DutchingCalculator;